<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap">
  <!-- Contenet page started-->
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
    <div class="loader2"></div>
</div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="aqu-table-heading">

      </div>
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <ul class="breadcrumb">
          <li><a routerLink="/home">Ambro Live</a></li>
          <li><a>Image Details</a></li>
        </ul>
      </div>
      <!-- breadcrumb End -->
      <div class="row" style="margin-bottom: 25px">
        <div class="imagetable">
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-2">
            <div class="imglabels" (click)="displayImageTypeTable('sam')">
              <span class="label_text">Sampling</span><span class="label_value"> {{samplingImageCount}}</span>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-2">
            <div class="imglabels" (click)="displayImageTypeTable('cti')">
              <span class="label_text">Checktray</span><span class="label_value"> {{ctiImageCount}}</span>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-2">
            <div class="imglabels" (click)="displayImageTypeTable('obs')">
              <span class="label_text">Observations</span><span class="label_value"> {{observationImageCount}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- START BASIC TABLE SAMPLE -->
      <div class="panel panel-default" [hidden]="!pgLoad" *ngIf="!issubDBImagesDisplay">
        <div class="panel-body table-responsive">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortImage('farm')">FARM NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':imageFarmname,'glyphicon-chevron-down':!imageFarmname}"></span>
              </th>
              <th class="handSymbol" (click)="sortImage('location')">LOCATION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':imagelocation,'glyphicon-chevron-down':!imagelocation}"></span>
              </th>
              <th class="handSymbol" (click)="sortImage('section_name')">SECTION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':imagesection,'glyphicon-chevron-down':!imagesection}"></span>
              </th>
              <th class="handSymbol" (click)="sortImage('pond_name')">POND NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':imagepondname,'glyphicon-chevron-down':!imagepondname}"></span>
              </th>
              <!--<th>DATE</th>-->
              <th>IMAGE TYPE</th>
              <th>IMAGE COUNT</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="let list of DBImagesDisplay  |  paginate: { itemsPerPage: noOfItemsPerPage, currentPage: currentPageNumber }; let i = index">
              <td>{{((currentPageNumber - 1) * noOfItemsPerPage) + i + 1}}</td>
              <td>{{list.Business_name}}</td>
              <td>{{list.location}}</td>
              <td>{{list.section_name}}</td>
              <td>{{list.pond_name}}</td>
              <!--<td>{{list.date_time}}</td>-->
              <td>{{list.image_type == 'cti' ? 'Check tray' : list.image_type == 'obs' ? 'Observation' : list.image_type == 'sam' ? 'Sampling' : '--NA--'}}</td>
              <td>{{list.image_count}}</td>

              <td class="viewimages" (click)="getAllImageDownload(list)" data-toggle="modal" data-target="#myModal">
                View
              </td>
            </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="pull-right pagination_div" *ngIf="DBImagesDisplay && DBImagesDisplay.length>20">
              <pagination-controls (pageChange)="currentPageNumber = $event"></pagination-controls>
            </div>
          </div>

        </div>
      </div>
      <!-- END BASIC TABLE SAMPLE -->

      <!-- Image view model popup-->

      <!-- Modal -->
      <div class="modal fade" id="myModal" role="dialog">
        <div *ngIf="!pgLoad">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="modal-dialog modal-xl">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div>
                  <span (click)="carouselClick('prev')"><i class="fa fa-angle-left arrowleft"
                                                           aria-hidden="true"></i></span>
                </div>
                <div class="col-xs-12 carouselImages">
                  <div class="carousel-item" *ngFor="let view of imageDetails let i = index"
                       [ngClass]="{'active' : i == carouselindex}">
                    <div class="imgdetails col-xs-10" *ngIf="view.meal">
                      <span style="margin-right: 15px;">Meal: {{view.meal}}</span>
                      <span>Location: {{view.location}}</span>
                      <div>
                        <img class="carouselimgs" [src]="view['image']" width="500" height="400">
                      </div>
                    </div>
                    <div class="imgdetails col-xs-10" *ngIf="view.observation_type">
                      <span style="margin-right: 15px;">Observation Type: {{view.observation_type}}</span>
                      <span>Location: {{view.location}}</span>
                      <p>Description: {{view.description}}</p>
                      <div>
                        <img class="carouselimgs" [src]="view['image']" width="500" height="400">
                      </div>
                    </div>
                    <div class="imgdetails col-xs-10" *ngIf="!view.observation_type && !view.meal">
                      <span>Location: {{view.location}}</span>
                      <div>
                        <img class="carouselimgs" [src]="view['image']" width="500" height="400">
                      </div>
                    </div>
                    <div class="col-xs-2">
                      <button type="button"   title="Close Popup" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <button (click)="imageDelete(view)" class="deleteImage" id="deletebtn"
                            *ngIf="loginPersonType!= 'Farmer' && loginPersonType!= 'Farm Manager' && loginPersonType!= 'Business Admin'">
                      Delete
                    </button>
                  </div>
                </div>
                <div>
                  <span (click)="carouselClick('next')"><i class="fa fa-angle-right arrowright" aria-hidden="true"></i></span>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="margin-top: 12%;">
            </div>
          </div>
        </div>
      </div>
      <!-- End Image view model popup-->
      <!-- CTI, sampling and observation tabel view-->
      <div class="panel panel-default" *ngIf="issubDBImagesDisplay">
        <div class="panel-body table-responsive">
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-xs-6">
              <h3>{{subDBImagesTitle}}</h3>
            </div>
            <div class="col-xs-6">
              <h3 class="imagesdataclose"><i class="fa fa-times" (click)="cancelSubDBImagesDisplay()"
                                             aria-hidden="true"></i></h3>
            </div>
          </div>
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortsubDBImages('subDBImagesfarm')">FARM NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':subDBImagesimageFarmname,'glyphicon-chevron-down':!subDBImagesimageFarmname}"></span>
              </th>
              <th class="handSymbol" (click)="sortsubDBImages('subDBImageslocation')">LOCATION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':subDBImagesimagelocation,'glyphicon-chevron-down':!subDBImagesimagelocation}"></span>
              </th>
              <th class="handSymbol" (click)="sortsubDBImages('subDBImagessection_name')">SECTION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':subDBImagesimagesection,'glyphicon-chevron-down':!subDBImagesimagesection}"></span>
              </th>
              <th class="handSymbol" (click)="sortsubDBImages('subDBImagespond_name')">POND NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':subDBImagesimagepondname,'glyphicon-chevron-down':!subDBImagesimagepondname}"></span>
              </th>
              <!--<th>DATE</th>-->
              <th>IMAGE TYPE</th>
              <th>IMAGE COUNT</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="let list of subDBImagesDisplay |  paginate: { itemsPerPage: noOfSampItemsPerPage, currentPage: currentSampPageNumber };  let i = index">
              <td>{{((currentSampPageNumber - 1) * noOfSampItemsPerPage) + i + 1}}</td>
              <td>{{list.Business_name}}</td>
              <td>{{list.location}}</td>
              <td>{{list.section_name}}</td>
              <td>{{list.pond_name}}</td>
              <!-- <td>{{list.date_time}}</td>-->
              <td>{{list.image_type == 'cti' ? 'Check tray' : list.image_type == 'obs' ? 'Observation' : list.image_type == 'sam' ? 'Sampling' : '--NA--'}}</td>
              <td>{{list.image_count}}</td>
              <td class="viewimages" (click)="getAllImageDownload(list)" data-toggle="modal" data-target="#myModal">
                View
              </td>
            </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="pull-right pagination_div"  *ngIf="subDBImagesDisplay && subDBImagesDisplay.length>20">
              <pagination-controls (pageChange)="currentSampPageNumber = $event"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
      <!-- End CTI tabel view-->
    </div>
  </div>
</div>
<!--  </div>
</div>-->
<style>
  .carousel-item {
    display: none;
  }

  .carousel-item.active {
    display: block;
  }
</style>
